const appEnv = import.meta.env.VITE_APP_ENV;
const isDev = appEnv ? appEnv !== 'production' : import.meta.env.DEV;

export const logger = {
  log: (...args: unknown[]) => { if (isDev) console.log(...args); },
  error: (...args: unknown[]) => { if (isDev) console.error(...args); },
  warn: (...args: unknown[]) => { if (isDev) console.warn(...args); },
};
